<template>
	<div id="app-container">
		<app-loading v-show="loadingVisibile"></app-loading>
		<!-- <app-welcome-modal v-if="showWelcomeModal"></app-welcome-modal> -->
		<app-story-modal v-if="$store.state.app.app.storyModal.show"></app-story-modal>
		<app-image-upload-modal v-if="$store.state.app.app.imageUploadModal.show"></app-image-upload-modal>
		<app-account-modal v-if="$store.state.app.app.accountModal.show"></app-account-modal>
		<app-groups-modal v-if="$store.state.app.app.groupsModal.show"></app-groups-modal>
		<app-unfollow-modal v-if="$store.state.app.app.unfollowModal.show"></app-unfollow-modal>
		<app-image-modal v-if="$store.state.app.app.imageModal.show"></app-image-modal>
		<app-notifications-modal v-if="$store.state.app.app.notificationsModal.show"></app-notifications-modal>
		<aside>
			<app-menu-bar :class="[openBarClass(menuOpen, menuClosed)]"></app-menu-bar>
			<app-green-bar :class="[openBarClass(menuOpen, greenClosed)]"></app-green-bar>
			<app-black-bar :class="[openBarClass(menuOpen, blackClosed)]"></app-black-bar>
			<app-activity-bar
				:class="[$store.state.app.app.activityBarOpen ? activityBarOpen : activityBarClosed]"
			></app-activity-bar>
		</aside>
		<div
			id="app"
			:class="[($store.state.app.app.menuOpen || $store.state.app.app.activityBarOpen) ? opaque : notOpaque]"
		>
			<app-header></app-header>
			<div class="app-body">
				<section class="main-container">
					<!-- <transition name="slide-fade" mode="out-in"> -->
					<keep-alive>
						<router-view></router-view>
					</keep-alive>
					<!-- </transition> -->
					<!-- <transition name="slide-fade" mode="out-in"> -->
					<router-view name="authView"></router-view>
					<!-- </transition> -->
				</section>
			</div>
			<app-bottom-nav v-if="$store.state.user.authUser !== null"></app-bottom-nav>
			<!-- <app-cookies></app-cookies> -->
		</div>
		<app-footer v-show="showFooter" :class="[$store.state.app.app.menuOpen ? opaque : notOpaque]"></app-footer>
	</div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import BottomNav from "./components/BottomNav.vue";
import Loading from "./components/Loading.vue";
import MenuBar from "./components/MenuBar.vue";
import GreenBar from "./components/GreenBar.vue";
import BlackBar from "./components/BlackBar.vue";
import RecentActivity from "./components/recent-activity/RecentActivity.vue";
import WelcomeModal from "./components/modals/WelcomeModal.vue";
import StoryModal from "./components/modals/StoryModal.vue";
import AccountModal from "./components/modals/AccountModal.vue";
import GroupsModal from "./components/modals/GroupsModal.vue";
import UnfollowModal from "./components/modals/UnfollowModal.vue";
import ImageModal from "./components/modals/ImageModal.vue";
import imageUploadModal from "./components/modals/ImageUploadModal.vue";
import NotificationsModal from "./components/modals/NotificationsModal.vue";
import Cookies from "./components/misc/Cookies.vue";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import { setTimeout } from "timers";
// import { initApp } from './resources/firebase'
// Alpha vantage api key: K6LFLEMGXU8F3L6T
const lastPosition = { x: 0, y: 0 };

export default {
    data() {
        return {
            loading: "Loading...",
            loadingVisibile: true,
            showFooter: false,
            menuOpen: "menu-open",
            menuClosed: "menu-closed",
            greenClosed: "green-closed",
            blackClosed: "black-closed",
            opaque: "opaque",
            notOpaque: "not-opaque",
            activityBarOpen: "activity-bar-open",
            activityBarClosed: "activity-bar-closed"
        };
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
        appBottomNav: BottomNav,
        appLoading: Loading,
        appMenuBar: MenuBar,
        appGreenBar: GreenBar,
        appBlackBar: BlackBar,
        appActivityBar: RecentActivity,
        appWelcomeModal: WelcomeModal,
        appStoryModal: StoryModal,
        appAccountModal: AccountModal,
        appGroupsModal: GroupsModal,
        appUnfollowModal: UnfollowModal,
        appImageModal: ImageModal,
        appImageUploadModal: imageUploadModal,
        appNotificationsModal: NotificationsModal,
        appCookies: Cookies
    },
    beforeMount() {
        firebase.auth().onAuthStateChanged(user => {
            this.$store.state.user.authUser = user;
        });
    },
    mounted() {
        const app = document.querySelector("#app");
        const appBody = document.querySelector(".app-body");

        setTimeout(() => {
            app.style.display = "block";
            appBody.style.display = "block";
            this.loadingVisibile = false;
            this.showFooter = true;
        }, 2500);
    },
    methods: {
        openBarClass(open, closed) {
            if (this.$store.state.app.app.menuOpen) {
                return open;
            } else {
                return closed;
            }
        }
    }
};
</script>

<style lang="css" src="./styles/appStyles.css"></style>
<style>
html {
    background-color: #101010;
    height: 100%;
    position: relative;
}

#app-container {
    position: relative;
    min-height: 100vh;
    -webkit-overflow-scrolling: touch !important;
}

.big-story-section {
    height: 90vh;
    position: relative;
    margin-top: 75px;
}

.big-story {
    /* background-image: url('https://images.unsplash.com/photo-1491479374536-444f7afba283?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=e3c73df953d0c0aae0115d84d41ab684&auto=format&fit=crop&w=1955&q=80'); */
    background-image: url("https://versus.uk.com/wp-content/uploads/2018/02/Nike-News-Football-Soccer-Nigeria-National-Team-Kit-4_77368.jpg");
    height: -webkit-fill-available;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
}

#app,
.app-body {
    font-family: "Avenir", "Nunito", Helvetica, Arial, sans-serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #fff;
    background-color: #101010;
    height: 100%;
    display: none;
    transition: all 0.5s ease;
    -webkit-overflow-scrolling: touch !important;
}

.app-body {
    padding-top: 20px;
    padding-bottom: 20px;
    position: relative;
    margin: auto;
    width: calc(100% - 35px);
    background-color: unset;
}

.main-container {
    transition: all 0.3s ease-in-out;
}

.main-container {
    min-height: 100vh; /* will cover the 100% of viewport */
    /* overflow: hidden; */
    display: block;
    position: relative;
    /* padding-top: 10px; */
    /* padding-bottom: 50px; */
}

.menu-closed {
    transform: translateX(-100%);
}

.menu-open {
    transform: translateX(0%);
}

.search-closed {
    transform: translateX(100%);
}

.search-open {
    transform: translateX(0%);
}

.green-closed {
    transition: all 0.7s ease-in-out !important;
    transform: translateX(-100%);
}

.black-closed {
    transition: all 0.9s ease-in-out !important;
    transform: translateX(-100%);
}

.activity-bar-open {
    transform: translateX(0%);
}

.activity-bar-closed {
    transform: translateX(100%);
}

.opaque {
    opacity: 0.2;
}

.not-opaque {
    opacity: 1;
}

.toasted.bubble {
    background-color: #2e6513 !important;
    border: 2px solid #3b8f12 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
}

.error-toast.bubble {
    background-color: #6b0c23 !important;
    border: 2px solid #b00931 !important;
}

#nprogress .bar {
    background: #51c715 !important;
}

#nprogress .spinner {
    display: none !important;
}

@media (min-width: 1376px) {
    .app-body {
        width: 1280px;
    }
}

@media only screen and (max-width: 940px) {
    .toasted.bubble {
        background-color: #2e6513 !important;
        font-weight: 600 !important;
        font-size: 13px !important;
    }

    .error-toast.bubble {
        background-color: #6b0c23 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue